import { defaultScheduledAtIso, isoToDatetimeLocalValue } from '@/lib/publishing/calendarMonth';
import type { PublishDialogTarget, PublishPlatform } from '@/lib/publishing/types';

/** Prefills the shared /clips publish dialog for a calendar day at 10:00 local. */
export function buildCalendarPublishTarget(
  clipId: string,
  platform: PublishPlatform,
  dayKey: string,
  timeZone: string,
): PublishDialogTarget {
  return {
    clipId,
    platform,
    initialWhen: 'later',
    initialDatetimeLocal: isoToDatetimeLocalValue(
      defaultScheduledAtIso(dayKey, timeZone),
      timeZone,
    ),
  };
}
